module.exports = __webpack_public_path__ + "img/content-bottom.67c44339.png";